import {
  Component,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormDialogDto } from 'src/app/data/models/dto/form-dialog.dto';

@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogInfo: FormDialogDto,
    private dialogRef: MatDialogRef<FormDialogComponent>
  ) {}

  confirm() {
    this.dialogRef.close(this.dialogInfo.inputInitialValue);
  }
}
